import script from "./SelectUploadsDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectUploadsDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./SelectUploadsDropdown.vue?vue&type=style&index=0&id=68c5095a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c5095a"]])

export default __exports__